module.exports = __webpack_public_path__ + "assets/f03f521f6efbc02353ab34ade45f2698.jpg";